import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationMasterdataComponent } from './component/transport-registration-masterdata.component';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { TransportDetailsModule } from '../../../common/components/transport-details/transport-details.module';



@NgModule({
  declarations: [
    TransportRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    TransportDetailsModule,
    CenteredScrollableContentModule,
    CommonLayoutModule,
    CommonTranslationModule
  ]
})
export class TransportRegistrationMasterdataModule { }
